import { jsxs, Fragment, jsx } from 'react/jsx-runtime';
import { memo, useRef, useState, useEffect } from 'react';
import { useEventHandlers } from '../../hooks/useEventHandlers';
import { useCurrentView } from '../ArcView/ViewContext';
import { ArcReactiveProp } from './ArcReactiveProp';
import { isEqual } from './isEqual';

function createWidget(WidgetConstructor) {
  function ArcWidget({
    eventHandlers,
    style,
    view: propsView,
    ...widgetProps
  }) {
    const ref = useRef(null);
    const view = useCurrentView(propsView);
    const [widget] = useState(
      new WidgetConstructor(widgetProps)
    );
    useEffect(() => {
      const widgetDiv = ref.current;
      if (!widgetDiv)
        return;
      widget.container = document.createElement("div");
      widgetDiv.append(widget.container);
      if ("view" in widget)
        widget.view = view;
      return () => {
        widgetDiv.replaceChildren();
      };
    }, [view, widget]);
    useEventHandlers(widget, eventHandlers);
    return /* @__PURE__ */ jsxs(Fragment, { children: [
      /* @__PURE__ */ jsx("div", { style, ref }),
      widgetProps && widget && Object.entries(widgetProps).map(([key, val]) => /* @__PURE__ */ jsx(
        ArcReactiveProp,
        {
          accessor: widget,
          property: key,
          value: val
        },
        key
      ))
    ] });
  }
  return memo(ArcWidget, isEqual);
}

export { createWidget };
